import './_leasing-offer-gallery.twig';
import './_leasing-offer-gallery.scss';

import $ from 'jquery';

const photoswipeClass = 'photoswipe';

const gallerySelector = '.leasing-offer-gallery';
const thumbSelector = '.leasing-offer-gallery__thumb-item';
const photoswipeInClonedSelector = `.slick-slide.slick-cloned .${photoswipeClass}`;

export const name = 'leasing-offer-gallery';

export function disable() {}

export function enable(context) {
  Array.from(context.querySelectorAll(gallerySelector)).forEach((gallery) => {
    const $slider = $('.simple-slider');
    Array.from(gallery.querySelectorAll(thumbSelector)).forEach((thumb) => {
      const thumbIndex = thumb.dataset.index;
      thumb.addEventListener('click', () => {
        $slider.slick('slickGoTo', thumbIndex);
      });
    });

    const removePhotoswipeFromClonedSlides = () => {
      Array.from(gallery.querySelectorAll(photoswipeInClonedSelector)).forEach(
        (photoswipe) => {
          photoswipe.classList.remove(photoswipeClass);
        },
      );
    };
    removePhotoswipeFromClonedSlides();
    $slider.on('afterChange', removePhotoswipeFromClonedSlides);
  });
}

export default enable;
